import {
  AutoComplete,
  Button,
  Col,
  Container,
  HeadingFour,
  HeadingTwo,
  Jumbotron,
  PostcodeAutocomplete,
  Row
} from 'hui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import Cookies from 'universal-cookie';
import { EventActions, EventCategories, EventLabels } from '../../constants/Analytics';
import defaultArticleImage from './images/default-article.png';
import { addEnglishArticleWord, getArticleImageMediaQueriesObject, ucfirst } from './utils';

const ColHero = styled(Col)`
  margin-top: 10px;

  .gq-postcode__container > input {
    margin-bottom: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    min-width: 140px;
  }
  a {
    min-width: 100px;
    padding: 12px 10px;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      padding: 12px 20px;
    }
  }
`;

const HrHero = styled.hr`
  border: 1px dotted #8e8f91;
  margin-left: -62px;
  margin-right: -60px;
  margin-top: 12px;
`;

const StyledJumbotron = styled(Jumbotron)`
  height: 85vh;
  min-height: 340px;
  max-height: 700px;
  display: flex;
  align-items: center;
  width: 100%;
  transition: 'background-image 0.2s ease-in';
`;

const ResponsiveContainer = styled(Container)`
  width: 100%;
`;

const getCorrectImageForMedia = images => {
  const breakpoints = {
    375: 'xs',
    480: 'sm',
    768: 'md'
  };
  const width = window.innerWidth;
  const bp =
    breakpoints[((Object.keys(breakpoints) as unknown) as number[]).find(bp => width <= bp)] ||
    'lg';
  return images[bp];
};

export default class HeroJumbotron extends Component<any, any> {
  static propTypes = {
    category: PropTypes.object,
    categoryPerson: PropTypes.string,
    categoryPersonPlural: PropTypes.string,
    classPrefix: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    submitSelection: PropTypes.func,
    heroImage: PropTypes.string,
    isModal: PropTypes.bool,
    setModalData: PropTypes.func
  };

  static defaultProps = {
    classPrefix: 'gq-postcode',
    name: 'gq-postcode',
    value: '',
    placeholder: 'Enter postcode',
    categoryPerson: '',
    categoryPersonPlural: '',
    heroImage: defaultArticleImage,
    isModal: false
  };

  UNSAFE_componentWillMount() {
    const cookies = new Cookies();
    if (typeof cookies.get('landing_postcode') !== 'undefined') {
      this.setState({ postcodeValue: String(cookies.get('landing_postcode')) });
    }
  }

  componentDidMount() {
    const cookies = new Cookies();
    if (typeof cookies.get('landing_postcode') !== 'undefined') {
      this.setState({ postcodeValue: cookies.get('landing_postcode') });
      if (typeof document !== 'undefined') {
        const node = document.querySelector('.gq-postcode__input') as HTMLInputElement;
        if (node) {
          node.focus();
        }
      }
    }

    if (typeof Image === 'undefined') {
      return;
    }

    const image = new Image();
    const src = getCorrectImageForMedia(getArticleImageMediaQueriesObject(this.props.heroImage));
    image.onload = () => this.setState({ bgImage: src });
    image.src = src;
  }

  state = {
    bgImage: undefined,
    postcodeValue: ''
  };

  onChange = postcodeValue => {
    this.setState({ postcodeValue });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    const postcodeValue = `${suggestion.postcode} - ${suggestion.suburb}`;
    this.setState({ postcodeValue: postcodeValue });
    if (this.props.isModal) {
      this.props.setModalData({
        postcodeValue: postcodeValue,
        isOpen: true
      });
    } else {
      this.submitAction(postcodeValue);
    }
  };

  onButtonClick = e => {
    e.preventDefault();
    if (this.props.isModal) {
      this.props.setModalData({
        postcodeValue: this.state.postcodeValue,
        isOpen: true
      });
    } else {
      this.submitAction(this.state.postcodeValue);
    }
  };

  submitAction = value => {
    const { submitSelection, category } = this.props;

    submitSelection(value, category, 'hero');
  };

  render() {
    const { postcodeValue, bgImage } = this.state;
    const { classPrefix, placeholder, name, categoryPerson, categoryPersonPlural } = this.props;
    const categoryPersonDisplay = !categoryPerson ? 'Tradie' : categoryPerson;
    const categoryPersonPluralDisplay = !categoryPersonPlural ? 'Tradies' : categoryPersonPlural;
    return (
      <div>
        <StyledJumbotron background={bgImage}>
          <ResponsiveContainer>
            <Row>
              <Col xs={12}>
                <HeadingTwo mb={1} mt={0} align="center">
                  Find {addEnglishArticleWord(categoryPersonDisplay.toLowerCase())} the easy way
                </HeadingTwo>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={0}>
                <HeadingFour as="h3" mt={1} align="center">
                  Where do you need {categoryPersonPluralDisplay.toLowerCase()}?
                </HeadingFour>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Row>
                  <ColHero xs={0} md={2} lg={3} />
                  <ColHero xs={7} md={4} lg={4}>
                    <AutoComplete classPrefix={classPrefix}>
                      <PostcodeAutocomplete
                        classPrefix={classPrefix}
                        value={postcodeValue}
                        name={name}
                        placeholder={placeholder}
                        onChange={this.onChange}
                        onSuggestionSelected={this.onSuggestionSelected}
                      />
                    </AutoComplete>
                  </ColHero>
                  <ColHero xs={5} md={4} lg={2}>
                    <Button
                      tag="a"
                      href="/get_quotes_simple"
                      color="primary"
                      block
                      data-ga-category={EventCategories.ARTICLES}
                      data-ga-action={EventActions.GET_QUOTES_HERO_CLICK_BUTTON}
                      data-ga-label={EventLabels.GET_QUOTES_HERO_CLICK_BUTTON}
                      onClick={this.onButtonClick}
                    >
                      Get Started
                    </Button>
                  </ColHero>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={0} md={12}>
                <div className="list-box">
                  <div className="list-block">
                    <div className="circle">
                      <div>1</div>
                    </div>
                    <div className="list-text">
                      Tell us
                      <br />
                      what you need
                    </div>
                  </div>
                  <div className="list-hr">
                    <HrHero />
                  </div>
                  <div className="list-block">
                    <div className="circle">
                      <div>2</div>
                    </div>
                    <div className="list-text">
                      {ucfirst(categoryPersonPlural)}
                      <br />
                      contact you
                    </div>
                  </div>
                  <div className="list-hr">
                    <HrHero />
                  </div>
                  <div className="list-block">
                    <div className="circle">
                      <div>3</div>
                    </div>
                    <div className="list-text">
                      You choose the best
                      <br />
                      {categoryPerson.toLowerCase()}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </ResponsiveContainer>
        </StyledJumbotron>
      </div>
    );
  }
}
